import type { AppSettings, AppState, Lang } from './types';

/** Сколько обращений к модели доступно во Free-режиме без регистрации.
 * Единый источник для всех гейтов лимита (auth, generation-manager, main,
 * session-attachments) — счётчик в localStorage 'avgexpert_free_activity_count'. */
export const FREE_MODE_LIMIT = 30;

export const state: AppState = {
  lang: (localStorage.getItem('gemma_lang') as Lang) || 'ru',
  contextSize: 4096,
  maxDocsAllowed: 3,
  currentUser: null,
  authToken: localStorage.getItem('avgexpert_token'),
  adminStatsInterval: null,
  healthInterval: null,
  inactivityTimeout: null,
  activityListenersBound: false,
  categories: {},
  welcomeHintsTimeout: null,
};

export const settings: AppSettings = {
  system_prompt: localStorage.getItem('gemma_system_prompt') || '',
  temperature: parseFloat(localStorage.getItem('gemma_temperature') || '0.7'),
  top_p: parseFloat(localStorage.getItem('gemma_top_p') || '0.9'),
  top_k: parseInt(localStorage.getItem('gemma_top_k') || '40', 10),
  min_p: parseFloat(localStorage.getItem('gemma_min_p') || '0.05'),
  repeat_penalty: parseFloat(localStorage.getItem('gemma_repeat_penalty') || '1.1'),
  api_key: localStorage.getItem('gemma_api_key') || '',
};
